import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Sparkles } from "lucide-react";

export default function Ticker() {
  const [messages, setMessages] = useState([]);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    api.get("/ticker").then((r) => {
      setMessages(r.data.messages || []);
      setEnabled(r.data.enabled !== false);
    }).catch(() => {});
  }, []);

  if (!enabled || messages.length === 0) return null;

  const Row = () => (
    <div className="flex items-center shrink-0" aria-hidden="true">
      {messages.map((m, i) => (
        <span key={i} className="flex items-center text-sm text-bone/90 whitespace-nowrap">
          <Sparkles size={13} className="text-gold mx-4 shrink-0" strokeWidth={1.75} />
          {m}
        </span>
      ))}
    </div>
  );

  return (
    <div className="w-full bg-black/70 backdrop-blur-sm border-y border-gold/25 overflow-hidden" data-testid="ticker">
      <div className="flex w-max animate-marquee py-2.5">
        <Row />
        <Row />
      </div>
    </div>
  );
}
